module.exports = __webpack_public_path__ + "assets/lotterying-btn-deb672f4.svga";